<template>
  <div>
    <Navigation />
    <div class="container">
      <div class="container__center">
        <div v-if="ready" class="center__container">
          <section class="contact">
            <div class="contact__left">
              <h1>Contact us</h1>
            </div>
            <div class="contact__right">
              <div class="contact__text">
                <div
                  v-for="contact in contacts"
                  :key="contact.title"
                  class="contact__text-item"
                >
                  {{ contact.title }}<br />
                  <span v-html="contact.content" /><br />
                </div>
                <!-- Henn GmbH<br />
                Augustenstraße 54<br />
                80333 Munich<br />
                Germany<br /><br />

                T.
                <a href="tel:+49089523570" class="hide__link"
                  >+49 (0)89 52 35 7-0</a
                ><br />
                F.
                <a href="tel:+4908952357123" class="hide__link"
                  >+49 (0)89 52 35 7-123</a
                ><br /><br />

                <a
                  href="mailto:+adproject.company@gmail.com"
                  class="email__link"
                  >adproject.company@gmail.com</a
                > -->
              </div>

              <!-- <div class="contact__social">
                <a href="https://www.instagram.com/ad_casa_/" target="_blank">
                  <img src="/images/contact/Instagram.svg" alt="instagram" />
                </a>
                <a href="http://" target="_blank" class="social_disabled">
                  <img src="/images/contact/In.svg" alt="In" />
                </a>
                <a href="http://" target="_blank" class="social_disabled">
                  <img src="/images/contact/Facebook.svg" alt="Facebook" />
                </a>
              </div> -->
            </div>
          </section>

          <div class="page__footer">
            <div class="footer__grey__block"></div>
            AA PLUS DEVELOPMENT | Architecture&Development ©{{ new Date().getFullYear() }}
          </div>
        </div>
      </div>
    </div>

    <!-- <a
            @click.prevent="onHideForm"
            :class="`form-close ${ formPopup ? 'isVisible' : '' }`"
        >
            <span></span>
        </a>
        <div class="container">
            <div class="container__left">
                
            </div>
            <div class="container__center _contacts">
                <div class="mobile-cursor _white">{{ mobileCursor }}</div>
                <div :class="`contacts ${ formPopup ? 'isHidden' : '' }`">
                    <div class="contacts__inner">
                        <div class="contacts__wrapper">
                            <div class="contacts__city">{{ $t('contacts_city') }}</div>
                            <div class="contacts__address">{{ $t('contacts_address') }}</div>
                            <div class="contacts__block">
                                <div class="contacts__item">
                                    <div class="contacts__name">{{ $t('contacts_phone') }}</div>
                                    <div class="contacts__value _phone">
                                        <a href="tel:+79014969223">7 (901) 496 92 23</a>
                                    </div>
                                </div>
                                <div class="contacts__item">
                                    <div class="contacts__name">email</div>
                                    <div class="contacts__value _email">
                                        <a href="mailto:adproject.company@gmail.com"><span>adproject.company</span>@gmail.com</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="`contact-popup ${ formPopup ? 'isActive' : '' }`">
                    <div class="contact-popup__inner">
                        <div
                            ref="contactForm"
                            class="contact-form"
                            @click="onShowForm"
                        >
                            <div :class="`contact-form__result ${ isSent ? 'isActive' : '' }`">
                                <div class="contact-form__result-inner">
                                    <div class="contact-form__result-title">{{ $t('contacts_sent') }}</div>
                                    <div class="contact-form__result-desc">{{ $t('contacts_weWillContact') }}</div>
                                </div>
                            </div>
                            <div class="contact-form__header">
                                {{ $t('contacts_orContactHere') }}
                            </div>
                            <div class="contact-form__top">
                                <div
                                    :class="`${ formData.name == '' ? '' : 'isFilled' } ${ formErrors.name ? 'isError' : '' } contact-form__top-block contact-form__input-wrapper`"
                                >
                                    <div class="contact-form__placeholder">{{ $t('contacts_form_name') }}</div>
                                    <input
                                        v-model="formData.name"
                                        class="contact-form__input"
                                        type="text"
                                    >
                                </div>
                                <div
                                    :class="`${ formData.phone == '' ? '' : 'isFilled' } ${ formErrors.phone ? 'isError' : '' } contact-form__top-block contact-form__input-wrapper`"
                                >
                                    <div class="contact-form__placeholder">{{ $t('contacts_form_phone') }}</div>
                                    <input
                                        v-model="formData.phone"
                                        class="contact-form__input"
                                        type="text"
                                    >
                                </div>
                                <div
                                    :class="`${ formData.email == '' ? '' : 'isFilled' } ${ formErrors.email ? 'isError' : '' } contact-form__top-block contact-form__input-wrapper`"
                                >
                                    <div class="contact-form__placeholder">Email</div>
                                    <input
                                        v-model="formData.email"
                                        class="contact-form__input"
                                        type="text"
                                    >
                                </div>
                            </div>
                            <div
                                :class="`${ formData.message == '' ? '' : 'isFilled' } ${ formErrors.message ? 'isError' : '' } contact-form__message contact-form__input-wrapper`"
                            >
                                <div class="contact-form__placeholder _textarea">{{ $t('contacts_form_message') }}</div>
                                <textarea
                                    v-model="formData.message"
                                    class="contact-form__input _textarea"
                                ></textarea>
                            </div>
                        </div>
                        <button
                            ref="contactButton"
                            class="contact-form__button"
                            @click="onSubmit"
                        >{{ isSending ? $t('contacts_form_sending') : ( isSent ? 'OK' : $t('contacts_form_send') ) }}</button>
                    </div>
                </div>
            </div>
            <div class="container__right">
                
            </div>
        </div> -->
  </div>
</template>

<script>
import Vue from 'vue'
import { TweenLite } from 'gsap'
import { globalMixin } from '../mixins'
import Navigation from '../components/Navigation.vue'

export default {
  mixins: [globalMixin],

  components: { Navigation },

  data() {
    return {
      ready: false,
      isSent: false,
      isSending: false,
      formPopup: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        message: '',
      },
      formErrors: {
        name: false,
        phone: false,
        email: false,
        message: false,
      },
      timeout: false,
      mobileCursor: Vue.i18n.translate('contacts_title'),
      contacts: [],
    }
  },

  methods: {
    getContacts() {
      this.$http
        .get(this.getApiURL(`getContacts?lang=${Vue.i18n.locale()}`))
        .then((response) => {
          this.contacts = response.data.contacts
          this.ready = true
        })
    },

    setFormButtomPosition() {
      const margin =
        (window.innerHeight - this.$refs.contactForm.clientHeight) / 4
      this.$refs.contactButton.style.marginBottom = margin + 'px'
    },

    onShowForm(event) {
      if (!this.formPopup) {
        this.formPopup = true
        this.$store.commit('setMenuBurger', false)
        TweenLite.set(this.$refs.contactButton, {
          opacity: 0,
        })
        this.timeout = setTimeout(() => {
          this.setFormButtomPosition()
          TweenLite.to(this.$refs.contactButton, 0.5, {
            opacity: 1,
          })
        }, 500)
        this.mobileCursor = Vue.i18n.translate('contacts_feedback')
      }
    },

    onHideForm(event) {
      if (this.formPopup) {
        this.formPopup = false
        this.$store.commit('setMenuBurger', true)
        clearTimeout(this.timeout)
        this.mobileCursor = Vue.i18n.translate('contacts_title')
      }
    },

    onSubmit() {
      const self = this

      if (this.isSent) {
        this.onHideForm()
        setTimeout(() => {
          this.isSent = false
        }, 500)
      } else {
        let form = this.formData
        let errors = this.formErrors

        for (var key in errors) {
          errors[key] = false
        }

        if (!form.name) {
          errors.name = true
        }

        if (!form.phone) {
          errors.phone = true
        }

        let re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!re.test(String(form.email).toLowerCase())) {
          errors.email = true
        }

        if (!form.message) {
          errors.message = true
        }

        let validated = true
        for (var key in errors) {
          if (errors[key]) {
            validated = false
          }
        }

        if (validated) {
          let str = ''
          for (var key in form) {
            if (str != '') {
              str += '&'
            }
            str += key + '=' + encodeURIComponent(form[key])
          }

          self.isSending = true
          this.$http
            .get(this.getApiURL('sendEmail') + '?' + str)
            .then((response) => {
              self.isSending = false
              self.isSent = true
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
  },

  mounted() {
    this.onPageLoaded()
    this.getContacts()
    this.$store.commit('setNavigationColor', 'black')
    this.$store.commit('setBackgroundColor', 'white')
    window.addEventListener('resize', () => {
      this.setFormButtomPosition()
    })
  },

  destroyed() {
    this.$store.commit('setBackgroundColor', 'white')
    this.$store.commit('setMenuBurger', true)
    window.removeEventListener('resize', () => {
      this.setFormButtomPosition()
    })
  },
}
</script>

<style lang="scss">
@import '../assets/vars.scss';

.contact {
  padding-top: rem(140px);
  min-height: 53vh;
  display: flex;

  @media #{$mb} {
    min-height: unset;
    padding-top: rem(80px);
    flex-direction: column;
  }

  .contact__social {
    margin-top: 0px;
    display: flex;
    gap: 62px;

    @media #{$mb} {
      justify-content: flex-start;
      width: 100%;
      gap: 30px;
      margin-top: 5px;
    }

    a:not(.social_disabled) {
      opacity: 1;
      transition: opacity 0.2s;
      &:hover {
        opacity: 0.7;
      }
    }

    .social_disabled {
      cursor: auto;
      opacity: 0.5;
    }
  }

  .contact__left {
    width: 403px;
    margin-right: 45px;
    @media(max-width: 1000px) {
      width: fit-content;
    }
    @media #{$mb} {
      width: 100%;
    }
  }

  .contact__right {
    margin-top: 145px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: -0.03em;
    display: flex;
    gap: 193px;
    @media(max-width: 1000px) {
      flex-direction: column;
      gap: 100px;
    }
    @media #{$mb} {
      margin-top: 60px;
      gap: 50px;
      flex-direction: column;
    }
  }

  &__text {
    &-item {
      &:not(:first-child) {
        margin-top: 1em;
      }
    }

    a {
      color: inherit;
    }
  }

  h1 {
    font-family: 'Didot';
    font-style: normal;
    font-weight: 400;
    font-size: rem(70px);
    line-height: 120%;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    @media #{$mb} {
        white-space: normal;
        font-size: rem(50px);
        letter-spacing: 0.05em;
    }
  }

  .email__link {
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-color: #d9d9d9;
    letter-spacing: -0.04em;
    text-decoration-thickness: 1px;
    color: inherit;
    transition: 0.2s;
    &:hover {
      text-decoration-thickness: 1px;
      text-decoration: underline;
    }
  }
}

.hide__link {
  color: inherit;
  text-decoration: none;
  &:hover {
    color: inherit;
    text-decoration: none;
  }
}

.contacts-list {
  min-height: 100vh;
  box-sizing: border-box;
  padding: rem(281px 60px 60px 133px);

  @media #{$mb} {
    padding: rem(204px 20px 80px);
  }

  &__item {
    &-title {
      font-weight: 400;
      font-size: rem(12px);
      line-height: rem(14px);
      letter-spacing: rem(0.334286px);
    }

    &-content {
      font-weight: 500;
      font-size: rem(18px);
      line-height: rem(24px);
      letter-spacing: rem(0.375px);
      margin-top: rem(10px);
      word-break: break-word;

      a {
        color: #ffffff;
        text-decoration: none;
      }
    }

    &:not(:first-child) {
      margin-top: rem(40px);
    }

    &:first-child {
      margin-bottom: rem(60px);

      .contacts-list__item {
        &-title {
          font-weight: 700;
          font-size: rem(30px);
          line-height: rem(36px);
          letter-spacing: rem(0.83125px);

          @media #{$mb} {
            font-weight: 700;
            font-size: rem(18px);
            line-height: rem(22px);
          }
        }

        &-content {
          font-weight: 700;
          font-size: rem(50px);
          line-height: rem(64px);
          letter-spacing: rem(1.9px);

          @media #{$mb} {
            font-weight: 700;
            font-size: rem(26px);
            line-height: rem(31px);
          }
        }
      }
    }
  }

  &__social {
    display: flex;
    margin: rem(60px 0 0);

    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: rem(180px);
      height: rem(75px);
      border: 1px solid #ffffff;
      svg path {
        fill: #ffffff;
      }

      @media #{$mb} {
        width: rem(100px);
        height: rem(47px);
      }

      &:not(:last-child) {
        border-right: none;
      }

      &:hover {
        background: #ffffff;
        svg path {
          fill: #303030;
        }
      }
    }
  }
}

.container__center {
  &._contacts {
    overflow: hidden;
  }
}

.contacts {
  position: relative;
  overflow: hidden;
  height: 100vh;
  display: flex;
  align-items: center;
  transition: all 0.5s ease;

  &.isHidden {
    opacity: 0;
    pointer-events: none;
  }
}

.contacts__inner {
  width: 100%;
}

.contacts__wrapper {
  padding-left: rem(60px);

  @media #{$mb} {
    padding: rem(0 20px);
  }
}

.contacts__city {
  font-weight: 700;
  font-size: rem(30px);
  color: #ffffff;
  letter-spacing: 0.83px;
  line-height: rem(36px);

  @media #{$mb} {
    font-size: rem(18px);
    letter-spacing: 0;
  }
}

.contacts__address {
  font-weight: 700;
  font-size: rem(64px);
  color: #ffffff;
  letter-spacing: 1.9px;
  line-height: rem(64px);
  margin-top: rem(40px);

  @media #{$mb} {
    font-size: rem(36px);
    letter-spacing: 0;
    line-height: rem(60px);
  }
}

.contacts__block {
  margin-top: rem(100px);
  display: flex;

  @media #{$mb} {
    margin-top: rem(22px);
    display: block;
  }
}

.contacts__item {
  margin-right: rem(150px);

  @media #{$mb} {
    margin: rem(20px) 0 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.contacts__name {
  font-size: rem(12px);
  color: #ffffff;
  letter-spacing: 0.33px;
  line-height: rem(14px);

  @media #{$mb} {
    font-size: rem(10px);
    letter-spacing: 0.28px;
  }
}

.contacts__value {
  font-weight: 500;
  font-size: rem(18px);
  color: #ffffff;
  letter-spacing: 0.38px;
  line-height: rem(24px);
  margin-top: rem(10px);

  @media #{$mb} {
    font-size: rem(14px);
    letter-spacing: 0.29px;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  &._phone {
    white-space: nowrap;
  }
}

.contact-popup {
  position: absolute;
  top: 0;
  left: rem(60px);
  right: rem(220px);
  bottom: 0;
  transform: translateY(100%) scale(0.9);
  transform-origin: 0 0;
  transition: all 0.5s ease;

  @media #{$mb} {
    left: rem(20px);
    right: rem(20px);
    transform-origin: 50% 0;
    transform: translateY(100%) scale(1);
  }

  &.isActive {
    left: 0;
    transform: translateY(0%) scale(1);

    @media #{$mb} {
      left: rem(20px);
      top: rem(68px);
    }

    .contact-form {
      transform: translateY(-50%);
      top: 50%;
      margin-top: 0;

      @media #{$mb} {
        top: 0;
        transform: translateY(0);
      }
    }

    .contact-form__header {
      opacity: 0;
      pointer-events: none;
    }
  }
}

.contact-form {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: rem(120px 60px 77px);
  box-sizing: border-box;
  margin-top: rem(-85px);
  transition: all 0.5s ease;

  @media #{$mb} {
    position: relative;
    margin-top: rem(-67px);
    padding: rem(48px 20px 48px);
  }
}

.contact-form__top {
  display: flex;
  justify-content: space-between;

  @media #{$mb} {
    display: block;
  }
}

.contact-form__top-block {
  width: 30%;

  @media #{$mb} {
    width: auto;
    margin-top: 32px;

    &:first-child {
      margin-top: 0;
    }
  }
}

.contact-form__input-wrapper {
  position: relative;

  &.isFilled {
    .contact-form__placeholder {
      transform: translateY(-80%) scale(0.55);
    }
  }

  &.isError {
    .contact-form__input {
      border-color: #ff8686;
    }
  }
}

.contact-form__input {
  border: 0 none;
  border-bottom: 1px solid rgba(48, 48, 48, 0.1);
  resize: none;
  padding: 0;
  margin: 0;
  font-size: rem(18px);
  height: rem(40px);
  outline: none;
  width: 100%;

  @media #{$mb} {
    font-weight: 500;
    font-size: rem(14px);
    color: #303030;
    letter-spacing: 0.29px;
    height: rem(32px);
  }

  &::-webkit-input-placeholder {
    color: #303030;
    letter-spacing: 0.38px;
  }
  &::-moz-placeholder {
    color: #303030;
    letter-spacing: 0.38px;
  }
  &:-ms-input-placeholder {
    color: #303030;
    letter-spacing: 0.38px;
  }
  &:-moz-placeholder {
    color: #303030;
    letter-spacing: 0.38px;
  }

  &._textarea {
    height: rem(152px);
    line-height: rem(24px);

    @media #{$mb} {
      height: rem(85px);
    }
  }
}

.contact-form__placeholder {
  position: absolute;
  color: #303030;
  letter-spacing: 0.38px;
  font-size: rem(18px);
  height: rem(40px);
  line-height: rem(40px);
  pointer-events: none;
  transform-origin: 0 50%;
  transition: all 0.2s ease;

  @media #{$mb} {
    font-size: rem(14px);
    color: #303030;
    letter-spacing: rem(0.29px);
    line-height: rem(32px);
  }

  &._textarea {
    line-height: rem(24px);
  }
}

.contact-form__message {
  margin-top: rem(72px);

  @media #{$mb} {
    margin-top: rem(40px);
  }
}

.contact-form__header {
  cursor: pointer;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  height: rem(85px);
  line-height: rem(85px);
  font-weight: 500;
  font-size: rem(18px);
  color: #303030;
  letter-spacing: 0.38px;
  text-align: center;
  background: #fff;
  transition: all 0.5s ease;

  @media #{$mb} {
    height: rem(67px);
    line-height: rem(67px);
    font-size: rem(14px);
    letter-spacing: 0;
  }
}

.form-close {
  z-index: 4;
  position: absolute;
  top: rem(40px);
  right: rem(29px);
  width: rem(28px);
  height: rem(28px);
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease;

  @media #{$mb} {
    top: rem(14px);
    right: rem(18px);
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: rem(19px);
    height: rem(19px);
    margin-top: rem(-(19/2) + px);
    margin-left: rem(-(19/2) + px);

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -1px;
      margin-left: rem(-12px);
      background: #fff;
      width: rem(24px);
      height: 2px;
    }

    &:before {
      transform: rotate(-45deg);
    }

    &:after {
      transform: rotate(45deg);
    }
  }

  &.isVisible {
    opacity: 1;
    pointer-events: auto;
  }
}

.contact-form__button {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 50%);
  bottom: 0;
  border: 0 none;
  background: transparent;
  outline: none;
  font-weight: 500;
  font-size: rem(18px);
  color: #ffffff;
  letter-spacing: 0.38px;
  text-align: right;
  line-height: rem(24px);
  cursor: pointer;

  @media #{$mb} {
    position: relative;
    margin-bottom: 0 !important;
    transform: translateX(-50%);
    margin-top: 20px;
  }
}

.contact-form__result {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease;

  &.isActive {
    opacity: 1;
  }
}

.contact-form__result-title {
  font-weight: 700;
  font-size: rem(30px);
  color: #303030;
  letter-spacing: 0.83px;
  text-align: center;
  line-height: rem(36px);
}

.contact-form__result-desc {
  font-size: rem(14px);
  color: #303030;
  letter-spacing: 0.2px;
  text-align: center;
  line-height: rem(32px);
  margin-top: rem(14px);
}
</style>
